/**
 * @file Trial/billing display helpers: formatBytes and daysRemaining.
 */

export function formatBytes(n) {
  const bytes = Number(n) || 0;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export function daysRemaining(isoDate) {
  if (!isoDate) return null;
  const end = new Date(isoDate).getTime();
  const ms = end - Date.now();
  if (Number.isNaN(ms)) return null;
  return Math.max(0, Math.ceil(ms / (24 * 60 * 60 * 1000)));
}
